import { render, staticRenderFns } from "./OrganizationUserSettings.vue?vue&type=template&id=c4f8f428&scoped=true&"
import script from "./OrganizationUserSettings.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUserSettings.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationUserSettings.vue?vue&type=style&index=0&id=c4f8f428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f8f428",
  null
  
)

export default component.exports